module.exports = __webpack_public_path__ + "img/sum.c2020728.webp";